{
  "pt": {
    "ticket_category": {
      "Decisions": "Decisão",
      "Issue": "Pós-Venda",
      "Regular": "Regular",
      "labels": {
        "ticket_category": "Tipo"
      }
    }
  }
}
